import { handleError } from "../../../../utils/helpers";
import { QueryParams } from "../../../../utils/types";
import { adminBaseApi } from "../../../api";
import {
  GetEventGuestResponse,
  GetEventGuestsResponse,
  GetEventTicketsBreakdownResponse,
  GetEventTicketsResponse,
} from "../../event/event.types";
import {
  GetAllEventsQuery,
  GetAllEventsResponse,
  GetAllUserEventsQuery,
  GetAllUserEventsResponse,
} from "./events.types";

export const adminEventsApi = adminBaseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getAllEvents: builder.query<GetAllEventsResponse, GetAllEventsQuery>({
      query: (params) => {
        return {
          url: `admin/events`,
          method: "GET",
          params: { ...params },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    getAllUserEvents: builder.query<
      GetAllUserEventsResponse,
      {
        userId: string;
        params: GetAllUserEventsQuery;
      }
    >({
      query: (params) => {
        return {
          url: `admin/users/${params.userId}/events`,
          method: "GET",
          params: { ...params.params },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    adminGetEventTickets: builder.query<
      GetEventTicketsResponse,
      QueryParams & { id?: string; slug?: string }
    >({
      query: ({ id, slug, ...params }) => {
        return {
          url: `events/${slug ? "slug/" : ""}${id ?? slug}/tickets`,
          method: "GET",
          params: params,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    adminGetEventTicketsBreakdown: builder.query<
      GetEventTicketsBreakdownResponse,
      QueryParams & { id: string }
    >({
      query: ({ id, ...params }) => {
        return {
          url: `events/${id}/ticket-breakdown`,
          method: "GET",
          params: params,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    adminGetEventGuests: builder.query<
      GetEventGuestsResponse,
      QueryParams & { id: string; search: string; status?: string }
    >({
      query: ({ id, ...params }) => {
        return {
          url: `guests/${id}`,
          method: "GET",
          params: {
            ...params,
            search: params.search === "" ? undefined : params.search,
            status: params.status,
          },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    adminGetEventGuest: builder.query<GetEventGuestResponse, { id: string }>({
      query: (params) => {
        return {
          url: `guests/${params.id}/details`,
          method: "GET",
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
  }),
});

export const {
  useGetAllEventsQuery,
  useGetAllUserEventsQuery,
  useAdminGetEventTicketsQuery,
  useAdminGetEventTicketsBreakdownQuery,
  useAdminGetEventGuestQuery,
  useAdminGetEventGuestsQuery,
} = adminEventsApi;
